"use client"

import React from 'react'
import Link from 'next/link'
import { ContactRound, MapPin, Mail, Phone } from 'lucide-react'
import { useGetWebsiteConfig } from '@/hooks/use-configuration'
import WebLogo from '@/components/common/WebLogo'

export default function ContactPage() {
  const { data: websiteConfig, isLoading } = useGetWebsiteConfig()

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-600 text-lg">Loading...</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-10">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-3xl overflow-hidden">
        <div className="px-6 py-8 md:px-10 md:py-12">
          <div className="mb-6 flex justify-center">
            <WebLogo />
          </div>

          <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-4">Contact Us</h1>
          <p className="text-center text-gray-500 mb-8">
            We’re here to help you 24/7. Reach out to us through any of the contact methods below.
          </p>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <MapPin className="text-blue-500 w-6 h-6 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-700">Company Name</p>
                <p className="text-lg text-gray-900">{websiteConfig?.businessName}</p>
                <p className="text-sm text-gray-500">{websiteConfig?.address}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Phone className="text-blue-500 w-6 h-6 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-700">Phone Support</p>
                <p className="text-lg text-gray-900">{websiteConfig?.customerSupport?.mobile}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Mail className="text-blue-500 w-6 h-6 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-700">Email Support</p>
                <Link
                  href={`mailto:${websiteConfig?.customerSupport?.email}`}
                  className="text-blue-600 hover:underline"
                >
                  {websiteConfig?.customerSupport?.email}
                </Link>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <ContactRound className="text-blue-500 w-6 h-6 mt-1" />
              <div>
                <p className="text-sm font-medium text-gray-700">Customer Support Availability</p>
                <p className="text-lg text-gray-900">24/7 Support</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
